import { FC } from "react";

import type { MainLineSettings, FibonacciSettings } from "../model";
import { MainLineSection } from "./MainLineSection";
import { ColorCheckRow } from "./ColorCheckRow";

interface Props {
  mainLine: MainLineSettings;
  fibonacci: FibonacciSettings;
  onMainLineChange: (value: MainLineSettings) => void;
  onFibonacciChange: (value: FibonacciSettings) => void;
}

export const FibonacciStylesTab: FC<Props> = ({
  mainLine,
  fibonacci,
  onMainLineChange,
  onFibonacciChange,
}) => (
  <div>
    <MainLineSection value={mainLine} onChange={onMainLineChange} />
    <ColorCheckRow
      label="Levels"
      color={fibonacci.levelsColor}
      visible={fibonacci.levelsVisible}
      onColorChange={(color) =>
        onFibonacciChange({ ...fibonacci, levelsColor: color })
      }
      onVisibleChange={(visible) =>
        onFibonacciChange({ ...fibonacci, levelsVisible: visible })
      }
    />
    <ColorCheckRow
      label="Values"
      color={fibonacci.valuesColor}
      visible={fibonacci.valuesVisible}
      onColorChange={(color) =>
        onFibonacciChange({ ...fibonacci, valuesColor: color })
      }
      onVisibleChange={(visible) =>
        onFibonacciChange({ ...fibonacci, valuesVisible: visible })
      }
    />
  </div>
);
